// extracted by mini-css-extract-plugin
export default {"reports-list":"MyReports_reports-list__g7lHF"};